import React from 'react';

import { SSRInlineCommentsInit } from './SSRInlineCommentsInit.tsx';

export const SSRInlineScriptsInit = ({}) => {
	return <SSRInlineCommentsInit />;
};
